/* eslint-disable @typescript-eslint/no-require-imports */
import '../jquery-setup.js';
import Frontend from '../app/other/frontend';

const frontend = new Frontend();
frontend.init();

window.toastr = require('toastr');
